export const LOGO_URL = "https://customer-assets.emergentagent.com/job_wellness-directory-5/artifacts/pf3cxvi9_Logo2026.png";

export const CATEGORY_IMAGES = {
  nutrition: [
    "https://images.unsplash.com/photo-1775498053538-ec293e32b963?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1755811248279-1ab13b7d4384?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1755811248324-3c9b7c8865fc?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1755811248324-c70c1f10a7fd?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1636044988743-92dfb6362eec?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1636044990022-97492e89a143?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1623489254660-db5b367881d9?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1636044989715-2d7409d1dfa9?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1649825319037-f30ea5b611c7?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1728129386664-1bb3196f1bce?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1764397514715-37a966071228?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1764397514672-63b1a7a79110?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1589948100953-963e39185fd6?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1598120851988-ca905a99944d?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1622597467836-f3285f2131b8?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1637174757804-1d4269785be8?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1775889184858-455bd3efc935?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1770839112008-f6a165687cca?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1771773527813-a0524607bcf0?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1760903124403-9d0d36867720?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1765894711192-d35787eee3b6?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1758513081894-d9850798133d?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1762631883355-0d1efe77032c?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1765009434133-88a3608a60df?w=600&h=400&fit=crop",
  ],
  fitness: [
    "https://images.unsplash.com/photo-1771586791190-97ed536c54af?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1765728617805-b9f22d64e5b3?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1744551472726-24a3eb12e82a?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1775993719568-290840203239?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1651077837628-52b3247550ae?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1626444232874-e72c020eeb0e?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1671581084344-3d83ae383a83?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1583473848882-f9a5bc7fd2ee?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1685633224745-2cd59a9610f9?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1686133369581-3513ce7e394f?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1765302762700-81992a568be5?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1717500250411-9c523d269000?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1717500251988-cc4f6e393a75?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1717500251741-cdbc93342d5a?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1754257320386-2aa79623257c?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1624917796481-7974b04f6e81?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1750074167875-d69874232eee?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1584132159078-b7577f70fbf6?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1758875569612-94d5e0f1a35f?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1467818488384-3a21f2b79959?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1520536194455-348162e0fe90?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1546749876-2088f8b19e09?w=600&h=400&fit=crop",
  ],
  recovery: [
    "https://images.unsplash.com/photo-1757689314932-bec6e9c39e51?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1559185590-765cdc663325?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1611876385388-94a5e97a219a?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1611876386219-bc4903e203eb?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1611876386354-a567c9ca9ecf?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1739869460285-ff25d838620a?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1764192114257-ae9ecf97eb6f?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1758607234692-51ac051a2a4d?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1769238506848-b9bef50c5aab?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1599744403700-b7330f3c4dbe?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1633466152316-d26e2ddfd831?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1599447421338-2d21d3530aeb?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1611073615626-4ab3627a5dd8?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1512291313931-d4291048e7b6?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1671581081106-283f2bcdef71?w=600&h=400&fit=crop",
    "https://images.unsplash.com/photo-1740748776786-74365e440be4?w=600&h=400&fit=crop",
  ],
  services: [
    "https://images.unsplash.com/photo-1512291505839-65ba15729a48?w=600&h=400&fit=crop",
    "https://images.pexels.com/photos/34159000/pexels-photo-34159000.jpeg?auto=compress&cs=tinysrgb&w=940",
    "https://images.pexels.com/photos/7789616/pexels-photo-7789616.jpeg?auto=compress&cs=tinysrgb&w=940",
    "https://images.pexels.com/photos/9064323/pexels-photo-9064323.jpeg?auto=compress&cs=tinysrgb&w=940",
    "https://images.unsplash.com/photo-1598555763574-dca77e10427e?w=600&h=400&fit=crop",
    "https://images.pexels.com/photos/6551439/pexels-photo-6551439.jpeg?auto=compress&cs=tinysrgb&w=940",
  ],
};

// Category fallback pools: these illustrate venue type and are never presented as venue photos.
const N = CATEGORY_IMAGES.nutrition;
const F = CATEGORY_IMAGES.fitness;
const R = CATEGORY_IMAGES.recovery;
const S = CATEGORY_IMAGES.services;

const VENUE_IMAGE_RULES = [
  // Wellness services
  [/counseling|therapy practice|hypnotherapy/i, [S[0], S[1], S[3]]],
  [/nutrition practice|wellness coaching/i, [S[1], S[0], S[2]]],
  [/acupuncture|chiropractic|naturopathic|kinesiology|chinese medicine/i, [S[4], S[2], S[1]]],
  [/personal training/i, [S[5], F[0], F[1]]],
  // Fitness
  [/pilates/i, [F[11], F[12], F[13], F[14]]],
  [/yoga|mindful movement/i, [F[4], F[5], F[6], R[12]]],
  [/crossfit|iron & flow/i, [F[18], F[21], F[9], F[20], F[8]]],
  [/boxing|mma/i, [F[7], F[10]]],
  [/swim|aquatic/i, [F[15], F[16], F[17]]],
  [/cycle|& row/i, [F[19], F[0]]],
  [/fitness center/i, [F[0], F[1], F[2], F[3]]],
  // Nutrition
  [/sushi/i, [N[18], N[16], N[19], N[17]]],
  [/poke/i, [N[7], N[16], N[19]]],
  [/juice|smoothie/i, [N[12], N[14], N[13], N[15]]],
  [/wellness cafe/i, [N[14], N[12], N[22]]],
  [/bakery/i, [N[22], N[20]]],
  [/cafe/i, [N[22], N[9], N[23], N[20]]],
  [/market|health foods/i, [N[21], N[13], N[15]]],
  [/mediterranean|grill/i, [N[3], N[2], N[8]]],
  [/green table/i, [N[6], N[4], N[5]]],
  [/kitchen/i, [N[0], N[1], N[5], N[2]]],
  // Recovery
  [/cryo|recovery lab|restore/i, [R[3], R[4], R[5], R[6]]],
  [/chiropractic|align spine/i, [R[1], R[0]]],
  [/mindfulness/i, [R[8], R[9], R[14], R[12]]],
  [/counseling/i, [R[15], R[10], R[13]]],
  [/float/i, [R[11], R[7]]],
  [/spa/i, [R[2], R[16], R[13], R[7]]],
  [/wellness center/i, [R[0], R[2], R[16], R[13]]],
];

function listingHash(listing) {
  const seed = (listing.name || "") + (listing.zone || "") + (listing.id || "");
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = ((hash << 5) - hash + seed.charCodeAt(i)) | 0;
  return Math.abs(hash);
}

function matchVenuePool(listing) {
  const evidence = `${listing.subcategory || ""} ${listing.name || ""}`;
  for (const [re, pool] of VENUE_IMAGE_RULES) {
    if (re.test(evidence)) return pool;
  }
  return null;
}

function absoluteListingPhoto(url) {
  if (!url) return "";
  return /^https?:\/\//i.test(url) ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`;
}

function getCategoryFallbackMedia(listing, offset = 0) {
  const hash = listingHash(listing);
  const pool = matchVenuePool(listing);
  if (pool) return { src: pool[(hash + offset) % pool.length], source: "category-fallback", label: "Category image", verified: false };
  const images = CATEGORY_IMAGES[listing.category] || CATEGORY_IMAGES.nutrition;
  return { src: images[(hash + offset) % images.length], source: "category-fallback", label: "Category image", verified: false };
}

export function getListingMediaCandidates(listing) {
  let photoUrls = [];
  if (listing.photoUrls?.length) photoUrls = listing.photoUrls;
  else if (listing.photoUrl) photoUrls = [listing.photoUrl];
  const ownerPhotos = photoUrls
    .filter(Boolean)
    .map((url) => ({ src: absoluteListingPhoto(url), source: "owner-photo", label: "Owner photo", verified: true }));
  const fallback = getCategoryFallbackMedia(listing);
  return ownerPhotos.length ? [...ownerPhotos, fallback] : [fallback];
}

export function getListingMedia(listing) {
  return getListingMediaCandidates(listing)[0];
}

export function getListingImage(listing) {
  return getListingMedia(listing).src;
}

export function getListingGalleryMedia(listing, count = 5) {
  const candidates = getListingMediaCandidates(listing);
  const ownerPhotos = candidates.filter((media) => media.source === "owner-photo");
  return ownerPhotos.length ? ownerPhotos.slice(0, count) : candidates.slice(0, 1);
}

export function getListingGallery(listing, count = 5) {
  return getListingGalleryMedia(listing, count).map((media) => media.src);
}

export const CATEGORY_ACCENT = {
  nutrition: "#D90429",
  fitness: "#0033A0",
  recovery: "#0A192F",
  services: "#0F766E",
  other: "#64748B",
};

export const GRADE_CONFIG = {
  "A+": { bg: "#0033A0", text: "#FFFFFF", meaning: "Exceptional — send community members here without hesitation" },
  "A":  { bg: "#2563EB", text: "#FFFFFF", meaning: "Strong — recommend freely" },
  "A-": { bg: "#60A5FA", text: "#0A192F", meaning: "Very good — minor reservations" },
  "B+": { bg: "#D90429", text: "#FFFFFF", meaning: "Good with guidance — advise on what to order/try" },
  "B":  { bg: "#EF4444", text: "#FFFFFF", meaning: "Navigable — specific guidance required" },
  "Pending Review": { bg: "#94A3B8", text: "#FFFFFF", meaning: "Recently added, under assessment" },
};

export const DOMAIN_INFO = {
  "D1 Metabolic":    { label: "Metabolic & Inflammatory",    color: "#D90429", desc: "Supports blood sugar balance, insulin sensitivity, and inflammatory pathways." },
  "D2 Hormonal":     { label: "Hormonal & Neuroendocrine",   color: "#0033A0", desc: "Supports thyroid, adrenal, and sex hormone balance." },
  "D3 Mitochondrial":{ label: "Energy & Recovery",           color: "#2563EB", desc: "Supports mitochondrial function and cellular energy production." },
  "D4 Sleep":        { label: "Sleep & Circadian",           color: "#0A192F", desc: "Supports melatonin, sleep onset, and circadian rhythm regulation." },
  "D5 Stress/HPA":   { label: "Stress & Autonomic",         color: "#EF4444", desc: "Supports the HPA axis and autonomic nervous system stress response." },
  "D6 Gut":          { label: "Gut & Nutrient Status",       color: "#60A5FA", desc: "Supports gut microbiome, digestive integrity, and nutrient absorption." },
  "D7 Cardiovascular":{ label: "Cardiovascular Health",     color: "#D90429", desc: "Supports heart health, blood pressure, and endothelial function." },
  "D8 Immune":       { label: "Immune & Inflammatory",       color: "#EF4444", desc: "Supports immune regulation and anti-inflammatory pathways." },
  "D9 Neurocognitive":{ label: "Brain Health & Cognition",  color: "#0033A0", desc: "Supports focus, memory, neuroprotection, and cognitive function." },
  "D10 Methylation": { label: "Methylation & Genomic",       color: "#0A192F", desc: "Supports DNA methylation, MTHFR pathways, and genomic stability." },
};

export const GRADES = ["A+", "A", "A-", "B+", "B"];

export const ZONES = [
  // Monmouth County
  "Neptune", "Asbury Park", "Red Bank", "Long Branch", "Freehold",
  "Manalapan", "Marlboro", "Holmdel", "Colts Neck",
  "Rumson", "Keyport", "Howell", "Wall",
  "Ocean Township", "Middletown", "Eatontown",
  "Tinton Falls", "Shrewsbury", "Fair Haven", "Little Silver",
  "Deal", "Belmar", "Spring Lake", "Manasquan",
  "Hazlet", "Aberdeen", "Matawan", "Farmingdale", "Englishtown",
  // Ocean County
  "Toms River", "Brick", "Point Pleasant", "Lakewood", "Jackson",
  "Barnegat", "Seaside Heights", "Lavallette", "Stafford", "Manahawkin",
  // Middlesex County
  "Old Bridge", "Sayreville", "South Amboy", "East Brunswick",
  "North Brunswick", "New Brunswick", "Edison", "Woodbridge",
  "Perth Amboy", "Metuchen", "South Plainfield", "Piscataway",
  // Somerset County
  "Franklin", "Bridgewater", "Somerville", "Bound Brook",
  // Mercer County
  "Princeton", "Hamilton", "Lawrence", "Ewing",
  // Burlington County
  "Mount Laurel", "Moorestown", "Burlington", "Medford",
  // Bergen County
  "Hackensack", "Paramus", "Fort Lee", "Englewood", "Ridgewood", "Teaneck",
  // Essex County
  "Newark", "Montclair", "Livingston", "West Orange", "Maplewood", "Millburn",
  // Hudson County
  "Jersey City", "Hoboken", "Weehawken", "North Bergen",
  // Passaic County
  "Wayne", "Clifton", "Passaic", "Paterson",
  // Morris County
  "Morristown", "Parsippany", "Denville", "Madison",
  // Union County
  "Westfield", "Summit", "Cranford", "Scotch Plains",
  // Camden County
  "Cherry Hill", "Voorhees", "Haddonfield", "Collingswood",
  // Atlantic County
  "Atlantic City", "Margate", "Ventnor", "Egg Harbor",
  // Cape May County
  "Cape May", "Wildwood", "Stone Harbor", "Avalon",
  // Gloucester County
  "Washington Township", "Deptford", "Woodbury",
  // --- NEW YORK ---
  // NYC
  "Manhattan", "Brooklyn", "Queens", "Bronx", "Staten Island",
  // Westchester
  "White Plains", "Yonkers", "New Rochelle", "Scarsdale", "Rye",
  // Long Island - Nassau
  "Garden City", "Great Neck", "Manhasset", "Rockville Centre", "Hempstead",
  // Long Island - Suffolk
  "Huntington", "Smithtown", "Babylon", "Islip", "Southampton",
  // Hudson Valley
  "Nyack", "Tarrytown", "Peekskill", "Newburgh",
  // --- PENNSYLVANIA ---
  // Philadelphia
  "Philadelphia Center City", "Rittenhouse", "Old City", "University City", "Fishtown",
  // Bucks County
  "Doylestown", "New Hope", "Newtown", "Langhorne",
  // Montgomery County PA
  "King of Prussia", "Ardmore", "Conshohocken", "Bryn Mawr",
  // Lehigh Valley
  "Allentown", "Bethlehem", "Easton",
  // --- CONNECTICUT ---
  // Fairfield County
  "Stamford", "Greenwich", "Westport", "Norwalk", "Darien", "Fairfield",
  // New Haven
  "New Haven", "Milford", "Hamden", "Guilford",
  // --- DELAWARE ---
  "Wilmington", "Newark DE", "Greenville", "Middletown DE",
  // --- MASSACHUSETTS ---
  "Back Bay", "Beacon Hill", "South End Boston", "Seaport", "Fenway", "Cambridge", "Somerville MA", "Brookline",
  "Newton", "Framingham", "Natick", "Wellesley",
  "Salem MA", "Beverly", "Marblehead",
  "Quincy", "Hingham", "Plymouth MA",
  "Worcester",
  // --- RHODE ISLAND ---
  "Providence", "Cranston", "Warwick", "Pawtucket",
  "Newport", "Middletown RI",
  // --- MARYLAND ---
  "Fells Point", "Hampden", "Canton", "Towson", "Locust Point",
  "Annapolis", "Severna Park",
  "Bethesda", "Rockville", "Silver Spring", "Gaithersburg",
  "Columbia MD", "Ellicott City",
  // --- WASHINGTON DC ---
  "Georgetown", "Dupont Circle", "Capitol Hill", "Navy Yard", "Adams Morgan", "Logan Circle",
  // --- VIRGINIA ---
  "Arlington", "Alexandria", "Tysons", "Reston", "Fairfax City",
  "Richmond", "Carytown", "Short Pump",
  "Virginia Beach", "Norfolk", "Chesapeake",
  // --- NEW HAMPSHIRE ---
  "Manchester", "Nashua", "Concord",
  "Portsmouth", "Exeter",
  // --- VERMONT ---
  "Burlington VT", "South Burlington", "Winooski",
  "Montpelier", "Stowe",
  // --- MAINE ---
  "Portland ME", "South Portland", "Cape Elizabeth",
  "Kennebunkport", "Ogunquit",
  // --- NORTH CAROLINA ---
  "Uptown Charlotte", "South End Charlotte", "NoDa", "Ballantyne", "Plaza Midwood",
  "Raleigh", "Durham", "Chapel Hill", "Cary NC",
  "Asheville", "West Asheville",
  // --- SOUTH CAROLINA ---
  "Charleston SC", "Mount Pleasant", "Daniel Island",
  "Greenville SC", "Travelers Rest",
  "Columbia SC", "Forest Acres",
  // --- GEORGIA ---
  "Buckhead", "Midtown Atlanta", "Old Fourth Ward", "Decatur GA", "Sandy Springs", "Alpharetta",
  "Savannah", "Tybee Island",
  // --- FLORIDA ---
  "Brickell", "Wynwood", "Coral Gables", "Miami Beach", "Coconut Grove",
  "Fort Lauderdale", "Hollywood FL",
  "Tampa", "St. Petersburg", "Clearwater",
  "Orlando", "Winter Park", "Lake Nona",
  "Jacksonville", "Ponte Vedra Beach",
  // --- TEXAS ---
  "South Congress", "East Austin", "The Domain", "Round Rock",
  "Uptown Dallas", "Deep Ellum", "Plano", "Fort Worth", "Frisco",
  "The Heights", "Montrose", "River Oaks", "The Woodlands", "Sugar Land",
  "The Pearl", "Alamo Heights", "Stone Oak",
  // --- ILLINOIS ---
  "River North", "Wicker Park", "Lincoln Park", "West Loop", "Logan Square", "Hyde Park",
  "Evanston", "Wilmette",
  "Naperville", "Oak Park",
  // --- OHIO ---
  "Short North", "German Village", "Dublin OH",
  "Ohio City", "Tremont", "Downtown Cleveland", "Lakewood OH",
  "Over-the-Rhine", "Oakley", "Mount Adams",
  // --- MICHIGAN ---
  "Midtown Detroit", "Corktown", "Royal Oak", "Birmingham MI", "Ann Arbor",
  "Grand Rapids", "East Grand Rapids",
  // --- CALIFORNIA ---
  "Santa Monica", "Venice", "West Hollywood", "Silver Lake", "Downtown LA",
  "Mission District", "Marina District", "SoMa", "Noe Valley",
  "Gaslamp Quarter", "La Jolla", "Pacific Beach", "North Park",
  "Irvine", "Newport Beach", "Huntington Beach",
  // --- COLORADO ---
  "LoDo", "RiNo", "Cherry Creek", "Denver Highlands",
  "Boulder", "Colorado Springs",
  // --- TENNESSEE ---
  "The Gulch", "East Nashville", "12 South", "Green Hills",
  "Midtown Memphis", "East Memphis", "Chattanooga",
  // --- ARIZONA ---
  "Downtown Phoenix", "Arcadia", "Tempe", "Scottsdale", "Tucson",
  // --- WASHINGTON ---
  "Capitol Hill Seattle", "Ballard", "Fremont", "Queen Anne", "Bellevue",
  "Tacoma", "Spokane",
  // --- MINNESOTA ---
  "North Loop", "Uptown Minneapolis", "St. Paul", "Edina",
  // --- MISSOURI ---
  "Country Club Plaza", "Crossroads Arts District", "Westport KC",
  "Central West End", "The Grove", "Clayton",
  // --- INDIANA ---
  "Broad Ripple", "Mass Ave", "Fountain Square", "Carmel",
];

export const ZONE_COORDS = {
  // Monmouth County
  "Neptune":          [40.2012, -74.0384],
  "Asbury Park":      [40.2204, -74.0120],
  "Red Bank":         [40.3468, -74.0746],
  "Long Branch":      [40.2987, -73.9876],
  "Freehold":         [40.2590, -74.2721],
  "Manalapan":        [40.3379, -74.3249],
  "Marlboro":         [40.3468, -74.2596],
  "Holmdel":          [40.3887, -74.1827],
  "Colts Neck":       [40.2879, -74.1693],
  "Rumson":           [40.3676, -73.9995],
  "Keyport":          [40.4373, -74.2016],
  "Howell":           [40.1762, -74.2027],
  "Wall":             [40.1629, -74.0668],
  "Ocean Township":   [40.2590, -74.0272],
  "Middletown":       [40.3993, -74.1179],
  "Eatontown":        [40.2962, -74.0510],
  "Tinton Falls":     [40.3040, -74.0940],
  "Shrewsbury":       [40.3293, -74.0616],
  "Fair Haven":       [40.3618, -74.0380],
  "Little Silver":    [40.3382, -74.0410],
  "Deal":             [40.2530, -73.9960],
  "Belmar":           [40.1782, -74.0220],
  "Spring Lake":      [40.1527, -74.0278],
  "Manasquan":        [40.1268, -74.0487],
  "Hazlet":           [40.4158, -74.1748],
  "Aberdeen":         [40.4170, -74.2240],
  "Matawan":          [40.4148, -74.2299],
  "Farmingdale":      [40.1960, -74.1740],
  "Englishtown":      [40.2970, -74.3580],
  // Ocean County
  "Toms River":       [39.9537, -74.1979],
  "Brick":            [40.0579, -74.1090],
  "Point Pleasant":   [40.0832, -74.0682],
  "Lakewood":         [40.0968, -74.2177],
  "Jackson":          [40.0984, -74.3585],
  "Barnegat":         [39.7532, -74.2229],
  "Seaside Heights":  [39.9443, -74.0731],
  "Lavallette":       [39.9707, -74.0688],
  "Stafford":         [39.7003, -74.2640],
  "Manahawkin":       [39.6943, -74.2590],
  // Middlesex County
  "Old Bridge":       [40.4151, -74.3654],
  "Sayreville":       [40.4590, -74.3609],
  "South Amboy":      [40.4779, -74.2907],
  "East Brunswick":   [40.4278, -74.4157],
  "North Brunswick":  [40.4501, -74.4790],
  "New Brunswick":    [40.4863, -74.4518],
  "Edison":           [40.5187, -74.4121],
  "Woodbridge":       [40.5576, -74.2846],
  "Perth Amboy":      [40.5068, -74.2654],
  "Metuchen":         [40.5432, -74.3632],
  "South Plainfield": [40.5751, -74.4115],
  "Piscataway":       [40.5569, -74.4601],
  // Somerset County
  "Franklin":         [40.4754, -74.5513],
  "Bridgewater":      [40.5941, -74.6049],
  "Somerville":       [40.5742, -74.6099],
  "Bound Brook":      [40.5684, -74.5385],
  // Mercer County
  "Princeton":        [40.3573, -74.6672],
  "Hamilton":         [40.2267, -74.6929],
  "Lawrence":         [40.2968, -74.7244],
  "Ewing":            [40.2698, -74.7999],
  // Burlington County
  "Mount Laurel":     [39.9340, -74.8910],
  "Moorestown":       [39.9688, -74.9489],
  "Burlington":       [40.0713, -74.8516],
  "Medford":          [39.8546, -74.8227],
  // Bergen County
  "Hackensack":       [40.8859, -74.0435],
  "Paramus":          [40.9445, -74.0752],
  "Fort Lee":         [40.8509, -73.9712],
  "Englewood":        [40.8929, -73.9726],
  "Ridgewood":        [40.9793, -74.1166],
  "Teaneck":          [40.8976, -74.0160],
  // Essex County
  "Newark":           [40.7357, -74.1724],
  "Montclair":        [40.8259, -74.2090],
  "Livingston":       [40.7879, -74.3150],
  "West Orange":      [40.7987, -74.2390],
  "Maplewood":        [40.7312, -74.2735],
  "Millburn":         [40.7260, -74.3245],
  // Hudson County
  "Jersey City":      [40.7178, -74.0431],
  "Hoboken":          [40.7440, -74.0324],
  "Weehawken":        [40.7693, -74.0218],
  "North Bergen":     [40.8043, -74.0121],
  // Passaic County
  "Wayne":            [40.9254, -74.2765],
  "Clifton":          [40.8584, -74.1638],
  "Passaic":          [40.8568, -74.1285],
  "Paterson":         [40.9168, -74.1718],
  // Morris County
  "Morristown":       [40.7968, -74.4816],
  "Parsippany":       [40.8578, -74.4260],
  "Denville":         [40.8924, -74.4774],
  "Madison":          [40.7598, -74.4174],
  // Union County
  "Westfield":        [40.6590, -74.3474],
  "Summit":           [40.7156, -74.3646],
  "Cranford":         [40.6584, -74.2996],
  "Scotch Plains":    [40.6373, -74.3890],
  // Camden County
  "Cherry Hill":      [39.9349, -74.9939],
  "Voorhees":         [39.8435, -74.9529],
  "Haddonfield":      [39.8915, -75.0378],
  "Collingswood":     [39.9184, -75.0713],
  // Atlantic County
  "Atlantic City":    [39.3643, -74.4229],
  "Margate":          [39.3276, -74.5035],
  "Ventnor":          [39.3404, -74.4774],
  "Egg Harbor":       [39.3790, -74.6489],
  // Cape May County
  "Cape May":         [38.9351, -74.9060],
  "Wildwood":         [38.9918, -74.8149],
  "Stone Harbor":     [39.0526, -74.7612],
  "Avalon":           [39.1010, -74.7177],
  // Gloucester County
  "Washington Township": [39.7468, -75.0716],
  "Deptford":         [39.8319, -75.1046],
  "Woodbury":         [39.8382, -75.1527],
  // --- NEW YORK ---
  "Manhattan":        [40.7831, -73.9712],
  "Brooklyn":         [40.6782, -73.9442],
  "Queens":           [40.7282, -73.7949],
  "Bronx":            [40.8448, -73.8648],
  "Staten Island":    [40.5795, -74.1502],
  "White Plains":     [41.0340, -73.7629],
  "Yonkers":          [40.9312, -73.8988],
  "New Rochelle":     [40.9115, -73.7824],
  "Scarsdale":        [40.9887, -73.7846],
  "Rye":              [40.9826, -73.6835],
  "Garden City":      [40.7268, -73.6343],
  "Great Neck":       [40.8007, -73.7285],
  "Manhasset":        [40.7979, -73.6990],
  "Rockville Centre": [40.6587, -73.6413],
  "Hempstead":        [40.7062, -73.6187],
  "Huntington":       [40.8682, -73.4257],
  "Smithtown":        [40.8559, -73.2007],
  "Babylon":          [40.6957, -73.3257],
  "Islip":            [40.7298, -73.2104],
  "Southampton":      [40.8843, -72.3893],
  "Nyack":            [41.0907, -73.9174],
  "Tarrytown":        [41.0762, -73.8585],
  "Peekskill":        [41.2901, -73.9204],
  "Newburgh":         [41.5034, -74.0104],
  // --- PENNSYLVANIA ---
  "Philadelphia Center City": [39.9526, -75.1652],
  "Rittenhouse":      [39.9490, -75.1720],
  "Old City":         [39.9523, -75.1426],
  "University City":  [39.9522, -75.1932],
  "Fishtown":         [39.9714, -75.1340],
  "Doylestown":       [40.3101, -75.1299],
  "New Hope":         [40.3640, -74.9510],
  "Newtown":          [40.2293, -74.9368],
  "Langhorne":        [40.1743, -74.9224],
  "King of Prussia":  [40.0893, -75.3963],
  "Ardmore":          [40.0068, -75.2860],
  "Conshohocken":     [40.0793, -75.3035],
  "Bryn Mawr":        [40.0210, -75.3163],
  "Allentown":        [40.6084, -75.4902],
  "Bethlehem":        [40.6259, -75.3705],
  "Easton":           [40.6868, -75.2207],
  // --- CONNECTICUT ---
  "Stamford":         [41.0534, -73.5387],
  "Greenwich":        [41.0262, -73.6282],
  "Westport":         [41.1415, -73.3579],
  "Norwalk":          [41.1177, -73.4082],
  "Darien":           [41.0787, -73.4690],
  "Fairfield":        [41.1412, -73.2637],
  "New Haven":        [41.3083, -72.9279],
  "Milford":          [41.2223, -73.0568],
  "Hamden":           [41.3959, -72.8968],
  "Guilford":         [41.2890, -72.6818],
  // --- DELAWARE ---
  "Wilmington":       [39.7391, -75.5398],
  "Newark DE":        [39.6837, -75.7497],
  "Greenville":       [39.7998, -75.6002],
  "Middletown DE":    [39.4496, -75.7163],
  // Massachusetts
  "Back Bay":         [42.3503, -71.0810],
  "Beacon Hill":      [42.3588, -71.0707],
  "South End Boston": [42.3388, -71.0765],
  "Seaport":          [42.3519, -71.0466],
  "Fenway":           [42.3467, -71.0972],
  "Cambridge":        [42.3736, -71.1097],
  "Somerville MA":    [42.3876, -71.0995],
  "Brookline":        [42.3318, -71.1212],
  "Newton":           [42.3370, -71.2092],
  "Framingham":       [42.2793, -71.4162],
  "Natick":           [42.2834, -71.3495],
  "Wellesley":        [42.2968, -71.2924],
  "Salem MA":         [42.5195, -70.8967],
  "Beverly":          [42.5584, -70.8800],
  "Marblehead":       [42.5001, -70.8578],
  "Quincy":           [42.2529, -71.0023],
  "Hingham":          [42.2418, -70.8898],
  "Plymouth MA":      [41.9584, -70.6673],
  "Worcester":        [42.2626, -71.8023],
  // Rhode Island
  "Providence":       [41.8240, -71.4128],
  "Cranston":         [41.7798, -71.4373],
  "Warwick":          [41.7001, -71.4162],
  "Pawtucket":        [41.8787, -71.3826],
  "Newport":          [41.4901, -71.3128],
  "Middletown RI":    [41.5456, -71.2917],
  // Maryland
  "Fells Point":      [39.2828, -76.5936],
  "Hampden":          [39.3299, -76.6205],
  "Canton":           [39.2796, -76.5765],
  "Towson":           [39.4015, -76.6019],
  "Locust Point":     [39.2715, -76.5928],
  "Annapolis":        [38.9784, -76.4922],
  "Severna Park":     [39.0704, -76.5452],
  "Bethesda":         [38.9847, -77.0947],
  "Rockville":        [39.0840, -77.1528],
  "Silver Spring":    [38.9907, -77.0261],
  "Gaithersburg":     [39.1434, -77.2014],
  "Columbia MD":      [39.2037, -76.8610],
  "Ellicott City":    [39.2673, -76.7983],
  // Washington DC
  "Georgetown":       [38.9096, -77.0654],
  "Dupont Circle":    [38.9097, -77.0434],
  "Capitol Hill":     [38.8866, -76.9962],
  "Navy Yard":        [38.8762, -77.0037],
  "Adams Morgan":     [38.9212, -77.0424],
  "Logan Circle":     [38.9096, -77.0296],
  // Virginia
  "Arlington":        [38.8816, -77.0910],
  "Alexandria":       [38.8048, -77.0469],
  "Tysons":           [38.9187, -77.2311],
  "Reston":           [38.9586, -77.3570],
  "Fairfax City":     [38.8462, -77.3064],
  "Richmond":         [37.5407, -77.4360],
  "Carytown":         [37.5537, -77.4780],
  "Short Pump":       [37.6501, -77.6136],
  "Virginia Beach":   [36.8529, -75.9780],
  "Norfolk":          [36.8508, -76.2859],
  "Chesapeake":       [36.7682, -76.2875],
  // New Hampshire
  "Manchester":       [42.9956, -71.4548],
  "Nashua":           [42.7654, -71.4676],
  "Concord":          [43.2081, -71.5376],
  "Portsmouth":       [43.0718, -70.7626],
  "Exeter":           [42.9814, -70.9478],
  // Vermont
  "Burlington VT":    [44.4759, -73.2121],
  "South Burlington": [44.4669, -73.1710],
  "Winooski":         [44.4914, -73.1857],
  "Montpelier":       [44.2601, -72.5754],
  "Stowe":            [44.4654, -72.6874],
  // Maine
  "Portland ME":      [43.6591, -70.2568],
  "South Portland":   [43.6415, -70.2409],
  "Cape Elizabeth":   [43.5637, -70.2000],
  "Kennebunkport":    [43.3617, -70.4767],
  "Ogunquit":         [43.2487, -70.5995],
  // North Carolina
  "Uptown Charlotte": [35.2271, -80.8431],
  "South End Charlotte": [35.2087, -80.8590],
  "NoDa":             [35.2495, -80.8040],
  "Ballantyne":       [35.0554, -80.8490],
  "Plaza Midwood":    [35.2205, -80.7920],
  "Raleigh":          [35.7796, -78.6382],
  "Durham":           [35.9940, -78.8986],
  "Chapel Hill":      [35.9132, -79.0558],
  "Cary NC":          [35.7915, -78.7811],
  "Asheville":        [35.5951, -82.5515],
  "West Asheville":   [35.5788, -82.5900],
  // South Carolina
  "Charleston SC":    [32.7765, -79.9311],
  "Mount Pleasant":   [32.8323, -79.8284],
  "Daniel Island":    [32.8637, -79.9075],
  "Greenville SC":    [34.8526, -82.3940],
  "Travelers Rest":   [34.9676, -82.4434],
  "Columbia SC":      [34.0007, -81.0348],
  "Forest Acres":     [34.0193, -80.9862],
  // Georgia
  "Buckhead":         [33.8384, -84.3800],
  "Midtown Atlanta":  [33.7838, -84.3830],
  "Old Fourth Ward":  [33.7666, -84.3722],
  "Decatur GA":       [33.7748, -84.2963],
  "Sandy Springs":    [33.9304, -84.3733],
  "Alpharetta":       [34.0754, -84.2941],
  "Savannah":         [32.0809, -81.0912],
  "Tybee Island":     [32.0002, -80.8457],
  // Florida
  "Brickell":         [25.7617, -80.1918],
  "Wynwood":          [25.8010, -80.1990],
  "Coral Gables":     [25.7215, -80.2684],
  "Miami Beach":      [25.7907, -80.1300],
  "Coconut Grove":    [25.7126, -80.2570],
  "Fort Lauderdale":  [26.1224, -80.1373],
  "Hollywood FL":     [26.0112, -80.1495],
  "Tampa":            [27.9506, -82.4572],
  "St. Petersburg":   [27.7676, -82.6403],
  "Clearwater":       [27.9659, -82.8001],
  "Orlando":          [28.5383, -81.3792],
  "Winter Park":      [28.6000, -81.3392],
  "Lake Nona":        [28.3772, -81.2497],
  "Jacksonville":     [30.3322, -81.6557],
  "Ponte Vedra Beach": [30.2396, -81.3856],
  // Texas
  "South Congress":   [30.2500, -97.7500],
  "East Austin":      [30.2635, -97.7180],
  "The Domain":       [30.4021, -97.7250],
  "Round Rock":       [30.5083, -97.6789],
  "Uptown Dallas":    [32.8007, -96.8025],
  "Deep Ellum":       [32.7846, -96.7784],
  "Plano":            [33.0198, -96.6989],
  "Fort Worth":       [32.7555, -97.3308],
  "Frisco":           [33.1507, -96.8236],
  "The Heights":      [29.7908, -95.3984],
  "Montrose":         [29.7472, -95.3902],
  "River Oaks":       [29.7565, -95.4194],
  "The Woodlands":    [30.1658, -95.4613],
  "Sugar Land":       [29.6197, -95.6349],
  "The Pearl":        [29.4433, -98.4800],
  "Alamo Heights":    [29.4841, -98.4658],
  "Stone Oak":        [29.6199, -98.4735],
  // Illinois
  "River North":      [41.8924, -87.6341],
  "Wicker Park":      [41.9088, -87.6796],
  "Lincoln Park":     [41.9214, -87.6513],
  "West Loop":        [41.8827, -87.6486],
  "Logan Square":     [41.9231, -87.7093],
  "Hyde Park":        [41.7943, -87.5907],
  "Evanston":         [42.0451, -87.6877],
  "Wilmette":         [42.0723, -87.7228],
  "Naperville":       [41.7508, -88.1535],
  "Oak Park":         [41.8850, -87.7845],
  // Ohio
  "Short North":      [39.9772, -83.0038],
  "German Village":   [39.9420, -82.9959],
  "Dublin OH":        [40.0992, -83.1141],
  "Ohio City":        [41.4847, -81.7050],
  "Tremont":          [41.4739, -81.6963],
  "Downtown Cleveland": [41.4993, -81.6944],
  "Lakewood OH":      [41.4820, -81.7982],
  "Over-the-Rhine":   [39.1121, -84.5155],
  "Oakley":           [39.1520, -84.4300],
  "Mount Adams":      [39.1078, -84.4938],
  // Michigan
  "Midtown Detroit":  [42.3528, -83.0658],
  "Corktown":         [42.3316, -83.0658],
  "Royal Oak":        [42.4895, -83.1446],
  "Birmingham MI":    [42.5467, -83.2113],
  "Ann Arbor":        [42.2808, -83.7430],
  "Grand Rapids":     [42.9634, -85.6681],
  "East Grand Rapids": [42.9412, -85.6100],
  // California
  "Santa Monica":     [34.0195, -118.4912],
  "Venice":           [33.9850, -118.4695],
  "West Hollywood":   [34.0900, -118.3617],
  "Silver Lake":      [34.0869, -118.2702],
  "Downtown LA":      [34.0407, -118.2468],
  "Mission District": [37.7599, -122.4148],
  "Marina District":  [37.8021, -122.4369],
  "SoMa":             [37.7785, -122.4056],
  "Noe Valley":       [37.7502, -122.4337],
  "Gaslamp Quarter":  [32.7113, -117.1603],
  "La Jolla":         [32.8328, -117.2713],
  "Pacific Beach":    [32.7970, -117.2356],
  "North Park":       [32.7405, -117.1296],
  "Irvine":           [33.6846, -117.8265],
  "Newport Beach":    [33.6189, -117.9298],
  "Huntington Beach": [33.6595, -117.9988],
  // Colorado
  "LoDo":             [39.7526, -105.0003],
  "RiNo":             [39.7620, -104.9800],
  "Cherry Creek":     [39.7169, -104.9536],
  "Denver Highlands": [39.7583, -105.0111],
  "Boulder":          [40.0150, -105.2705],
  "Colorado Springs": [38.8339, -104.8214],
  // Tennessee
  "The Gulch":        [36.1520, -86.7856],
  "East Nashville":   [36.1770, -86.7510],
  "12 South":         [36.1230, -86.7894],
  "Green Hills":      [36.1030, -86.8160],
  "Midtown Memphis":  [35.1380, -89.9920],
  "East Memphis":     [35.1090, -89.8630],
  "Chattanooga":      [35.0456, -85.3097],
  // Arizona
  "Downtown Phoenix": [33.4484, -112.0740],
  "Arcadia":          [33.4980, -111.9880],
  "Tempe":            [33.4255, -111.9400],
  "Scottsdale":       [33.4942, -111.9261],
  "Tucson":           [32.2226, -110.9747],
  // Washington
  "Capitol Hill Seattle": [47.6230, -122.3190],
  "Ballard":          [47.6685, -122.3860],
  "Fremont":          [47.6510, -122.3500],
  "Queen Anne":       [47.6370, -122.3570],
  "Bellevue":         [47.6101, -122.2015],
  "Tacoma":           [47.2529, -122.4443],
  "Spokane":          [47.6588, -117.4260],
  // Minnesota
  "North Loop":       [44.9855, -93.2777],
  "Uptown Minneapolis": [44.9480, -93.2980],
  "St. Paul":         [44.9537, -93.0900],
  "Edina":            [44.8897, -93.3499],
  // Missouri
  "Country Club Plaza": [39.0420, -94.5910],
  "Crossroads Arts District": [39.0920, -94.5830],
  "Westport KC":      [39.0520, -94.5960],
  "Central West End": [38.6440, -90.2610],
  "The Grove":        [38.6270, -90.2540],
  "Clayton":          [38.6426, -90.3237],
  // Indiana
  "Broad Ripple":     [39.8700, -86.1420],
  "Mass Ave":         [39.7740, -86.1470],
  "Fountain Square":  [39.7520, -86.1420],
  "Carmel":           [39.9784, -86.1180],
  "default":          [40.25,   -74.30  ],
};

// County groupings for the filter
export const COUNTY_GROUPS = {
  "Monmouth": ["Neptune", "Asbury Park", "Red Bank", "Long Branch", "Freehold", "Manalapan", "Marlboro", "Holmdel", "Colts Neck", "Rumson", "Keyport", "Howell", "Wall", "Ocean Township", "Middletown", "Eatontown", "Tinton Falls", "Shrewsbury", "Fair Haven", "Little Silver", "Deal", "Belmar", "Spring Lake", "Manasquan", "Hazlet", "Aberdeen", "Matawan", "Farmingdale", "Englishtown"],
  "Ocean": ["Toms River", "Brick", "Point Pleasant", "Lakewood", "Jackson", "Barnegat", "Seaside Heights", "Lavallette", "Stafford", "Manahawkin"],
  "Middlesex": ["Old Bridge", "Sayreville", "South Amboy", "East Brunswick", "North Brunswick", "New Brunswick", "Edison", "Woodbridge", "Perth Amboy", "Metuchen", "South Plainfield", "Piscataway"],
  "Somerset": ["Franklin", "Bridgewater", "Somerville", "Bound Brook"],
  "Mercer": ["Princeton", "Hamilton", "Lawrence", "Ewing"],
  "Burlington": ["Mount Laurel", "Moorestown", "Burlington", "Medford"],
  "Bergen": ["Hackensack", "Paramus", "Fort Lee", "Englewood", "Ridgewood", "Teaneck"],
  "Essex": ["Newark", "Montclair", "Livingston", "West Orange", "Maplewood", "Millburn"],
  "Hudson": ["Jersey City", "Hoboken", "Weehawken", "North Bergen"],
  "Passaic": ["Wayne", "Clifton", "Passaic", "Paterson"],
  "Morris": ["Morristown", "Parsippany", "Denville", "Madison"],
  "Union": ["Westfield", "Summit", "Cranford", "Scotch Plains"],
  "Camden": ["Cherry Hill", "Voorhees", "Haddonfield", "Collingswood"],
  "Atlantic": ["Atlantic City", "Margate", "Ventnor", "Egg Harbor"],
  "Cape May": ["Cape May", "Wildwood", "Stone Harbor", "Avalon"],
  "Gloucester": ["Washington Township", "Deptford", "Woodbury"],
  // New York
  "New York City": ["Manhattan", "Brooklyn", "Queens", "Bronx", "Staten Island"],
  "Westchester": ["White Plains", "Yonkers", "New Rochelle", "Scarsdale", "Rye", "Tarrytown", "Peekskill"],
  "Nassau": ["Garden City", "Great Neck", "Manhasset", "Rockville Centre", "Hempstead"],
  "Suffolk": ["Huntington", "Smithtown", "Babylon", "Islip", "Southampton"],
  "Rockland": ["Nyack"],
  "Orange NY": ["Newburgh"],
  // Pennsylvania
  "Philadelphia": ["Philadelphia Center City", "Rittenhouse", "Old City", "University City", "Fishtown"],
  "Bucks": ["Doylestown", "New Hope", "Newtown", "Langhorne"],
  "Montgomery PA": ["King of Prussia", "Ardmore", "Conshohocken", "Bryn Mawr"],
  "Lehigh": ["Allentown"],
  "Northampton": ["Bethlehem", "Easton"],
  // Connecticut
  "Fairfield CT": ["Stamford", "Greenwich", "Westport", "Norwalk", "Darien", "Fairfield"],
  "New Haven CT": ["New Haven", "Milford", "Hamden", "Guilford"],
  // Delaware
  "New Castle": ["Wilmington", "Newark DE", "Greenville", "Middletown DE"],
  // Massachusetts
  "Greater Boston": ["Back Bay", "Beacon Hill", "South End Boston", "Seaport", "Fenway", "Cambridge", "Somerville MA", "Brookline"],
  "MetroWest": ["Newton", "Framingham", "Natick", "Wellesley"],
  "North Shore MA": ["Salem MA", "Beverly", "Marblehead"],
  "South Shore MA": ["Quincy", "Hingham", "Plymouth MA"],
  "Worcester": ["Worcester"],
  // Rhode Island
  "Providence": ["Providence", "Cranston", "Warwick", "Pawtucket"],
  "Newport County": ["Newport", "Middletown RI"],
  // Maryland
  "Baltimore": ["Fells Point", "Hampden", "Canton", "Towson", "Locust Point"],
  "Annapolis": ["Annapolis", "Severna Park"],
  "Montgomery MD": ["Bethesda", "Rockville", "Silver Spring", "Gaithersburg"],
  "Howard MD": ["Columbia MD", "Ellicott City"],
  // Washington DC
  "Washington DC": ["Georgetown", "Dupont Circle", "Capitol Hill", "Navy Yard", "Adams Morgan", "Logan Circle"],
  // Virginia
  "Northern Virginia": ["Arlington", "Alexandria", "Tysons", "Reston", "Fairfax City"],
  "Richmond Metro": ["Richmond", "Carytown", "Short Pump"],
  "Hampton Roads": ["Virginia Beach", "Norfolk", "Chesapeake"],
  // New Hampshire
  "Southern New Hampshire": ["Manchester", "Nashua", "Concord"],
  "NH Seacoast": ["Portsmouth", "Exeter"],
  // Vermont
  "Burlington Metro": ["Burlington VT", "South Burlington", "Winooski"],
  "Central Vermont": ["Montpelier", "Stowe"],
  // Maine
  "Portland Maine": ["Portland ME", "South Portland", "Cape Elizabeth"],
  "Southern Maine Coast": ["Kennebunkport", "Ogunquit"],
  // North Carolina
  "Charlotte Metro": ["Uptown Charlotte", "South End Charlotte", "NoDa", "Ballantyne", "Plaza Midwood"],
  "The Triangle": ["Raleigh", "Durham", "Chapel Hill", "Cary NC"],
  "Asheville": ["Asheville", "West Asheville"],
  // South Carolina
  "Charleston Metro": ["Charleston SC", "Mount Pleasant", "Daniel Island"],
  "Greenville Upstate": ["Greenville SC", "Travelers Rest"],
  "Columbia Midlands": ["Columbia SC", "Forest Acres"],
  // Georgia
  "Atlanta Metro": ["Buckhead", "Midtown Atlanta", "Old Fourth Ward", "Decatur GA", "Sandy Springs", "Alpharetta"],
  "Savannah": ["Savannah", "Tybee Island"],
  // Florida
  "Miami Metro": ["Brickell", "Wynwood", "Coral Gables", "Miami Beach", "Coconut Grove"],
  "Fort Lauderdale": ["Fort Lauderdale", "Hollywood FL"],
  "Tampa Bay": ["Tampa", "St. Petersburg", "Clearwater"],
  "Orlando Metro": ["Orlando", "Winter Park", "Lake Nona"],
  "Jacksonville": ["Jacksonville", "Ponte Vedra Beach"],
  // Texas
  "Austin Metro": ["South Congress", "East Austin", "The Domain", "Round Rock"],
  "Dallas-Fort Worth": ["Uptown Dallas", "Deep Ellum", "Plano", "Fort Worth", "Frisco"],
  "Houston Metro": ["The Heights", "Montrose", "River Oaks", "The Woodlands", "Sugar Land"],
  "San Antonio": ["The Pearl", "Alamo Heights", "Stone Oak"],
  // Illinois
  "Chicago Metro": ["River North", "Wicker Park", "Lincoln Park", "West Loop", "Logan Square", "Hyde Park"],
  "North Shore Chicago": ["Evanston", "Wilmette"],
  "Chicago West Suburbs": ["Naperville", "Oak Park"],
  // Ohio
  "Columbus Metro": ["Short North", "German Village", "Dublin OH"],
  "Cleveland Metro": ["Ohio City", "Tremont", "Downtown Cleveland", "Lakewood OH"],
  "Cincinnati Metro": ["Over-the-Rhine", "Oakley", "Mount Adams"],
  // Michigan
  "Detroit Metro": ["Midtown Detroit", "Corktown", "Royal Oak", "Birmingham MI", "Ann Arbor"],
  "Grand Rapids": ["Grand Rapids", "East Grand Rapids"],
  // California
  "Los Angeles": ["Santa Monica", "Venice", "West Hollywood", "Silver Lake", "Downtown LA"],
  "San Francisco": ["Mission District", "Marina District", "SoMa", "Noe Valley"],
  "San Diego": ["Gaslamp Quarter", "La Jolla", "Pacific Beach", "North Park"],
  "Orange County": ["Irvine", "Newport Beach", "Huntington Beach"],
  // Colorado
  "Denver Metro": ["LoDo", "RiNo", "Cherry Creek", "Denver Highlands"],
  "Boulder": ["Boulder"],
  "Colorado Springs": ["Colorado Springs"],
  // Tennessee
  "Nashville Metro": ["The Gulch", "East Nashville", "12 South", "Green Hills"],
  "Memphis": ["Midtown Memphis", "East Memphis"],
  "Chattanooga": ["Chattanooga"],
  // Arizona
  "Phoenix Metro": ["Downtown Phoenix", "Arcadia", "Tempe", "Scottsdale"],
  "Tucson": ["Tucson"],
  // Washington
  "Seattle Metro": ["Capitol Hill Seattle", "Ballard", "Fremont", "Queen Anne", "Bellevue"],
  "Tacoma": ["Tacoma"],
  "Spokane": ["Spokane"],
  // Minnesota
  "Twin Cities": ["North Loop", "Uptown Minneapolis", "St. Paul", "Edina"],
  // Missouri
  "Kansas City": ["Country Club Plaza", "Crossroads Arts District", "Westport KC"],
  "St. Louis": ["Central West End", "The Grove", "Clayton"],
  // Indiana
  "Indianapolis": ["Broad Ripple", "Mass Ave", "Fountain Square", "Carmel"],
};

// Requests needed before a planned market enters launch review
export const LAUNCH_GOAL = 50;

// Markets whose browse pages should NOT be labelled "<name> County"
export const NON_COUNTY_MARKETS = new Set([
  "New York City", "Philadelphia",
  "Greater Boston", "MetroWest", "North Shore MA", "South Shore MA", "Worcester",
  "Providence", "Newport County",
  "Baltimore", "Annapolis", "Montgomery MD", "Howard MD",
  "Washington DC",
  "Northern Virginia", "Richmond Metro", "Hampton Roads",
  "Southern New Hampshire", "NH Seacoast",
  "Burlington Metro", "Central Vermont",
  "Portland Maine", "Southern Maine Coast",
  "Charlotte Metro", "The Triangle", "Asheville",
  "Charleston Metro", "Greenville Upstate", "Columbia Midlands",
  "Atlanta Metro", "Savannah",
  "Miami Metro", "Fort Lauderdale", "Tampa Bay", "Orlando Metro", "Jacksonville",
  "Austin Metro", "Dallas-Fort Worth", "Houston Metro", "San Antonio",
  "Chicago Metro", "North Shore Chicago", "Chicago West Suburbs",
  "Columbus Metro", "Cleveland Metro", "Cincinnati Metro",
  "Detroit Metro", "Grand Rapids",
  "Los Angeles", "San Francisco", "San Diego", "Orange County",
  "Denver Metro", "Boulder", "Colorado Springs",
  "Nashville Metro", "Memphis", "Chattanooga",
  "Phoenix Metro", "Tucson",
  "Seattle Metro", "Tacoma", "Spokane",
  "Twin Cities",
  "Kansas City", "St. Louis",
  "Indianapolis",
]);

// State abbr -> full name (shared by Areas + State landing pages)
export const STATE_NAMES = {
  NJ: "New Jersey", NY: "New York", PA: "Pennsylvania", CT: "Connecticut", DE: "Delaware",
  MA: "Massachusetts", RI: "Rhode Island", MD: "Maryland", DC: "Washington DC", VA: "Virginia",
  NH: "New Hampshire", VT: "Vermont", ME: "Maine",
  AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas", CA: "California", CO: "Colorado",
  FL: "Florida", GA: "Georgia", HI: "Hawaii", ID: "Idaho", IL: "Illinois", IN: "Indiana",
  IA: "Iowa", KS: "Kansas", KY: "Kentucky", LA: "Louisiana", MI: "Michigan", MN: "Minnesota",
  MS: "Mississippi", MO: "Missouri", MT: "Montana", NE: "Nebraska", NV: "Nevada", NM: "New Mexico",
  NC: "North Carolina", ND: "North Dakota", OH: "Ohio", OK: "Oklahoma", OR: "Oregon",
  SC: "South Carolina", SD: "South Dakota", TN: "Tennessee", TX: "Texas", UT: "Utah",
  WA: "Washington", WV: "West Virginia", WI: "Wisconsin", WY: "Wyoming",
};

// States with live coverage (mirrors backend expansion3_data.STATE_NAME_MAP) — used for crawlable state landing links
export const LIVE_STATE_CODES = ["NJ", "NY", "PA", "CT", "DE", "MA", "RI", "MD", "DC", "VA", "NH", "VT", "ME", "NC", "SC", "GA", "FL", "TX", "IL", "OH", "MI", "CA", "CO", "TN", "AZ", "WA", "MN", "MO", "IN"];

export const stateSlug = (abbr) =>
  (STATE_NAMES[abbr] || abbr).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const stateFromSlug = (slug) =>
  Object.keys(STATE_NAMES).find((k) => stateSlug(k) === slug) || null;

// Derive the 2-letter state from a listing's address (addresses end ", XX")
export function getListingState(listing) {
  const m = (listing?.address || "").match(/,\s*([A-Z]{2})\s*$/);
  return m ? m[1] : "NJ";
}

// Returns [lat, lng] for a listing — zone-based with deterministic jitter
export function hasRealCoords(listing) {
  return Number.isFinite(listing?.lat) && Number.isFinite(listing?.lng);
}

// Prefer geocoded coordinates; fall back to the zone centroid with a stable per-listing offset.
export function getListingCoords(listing) {
  if (hasRealCoords(listing)) return [listing.lat, listing.lng];
  const zone = listing.zone || "default";
  const base = ZONE_COORDS[zone] || ZONE_COORDS["default"];
  const hash = listing.id
    ? listing.id.split("").reduce((acc, ch, i) => acc + ch.charCodeAt(0) * (i + 1), 0)
    : 0;
  const latJitter = ((hash % 100) - 50) * 0.0007;
  const lngJitter = ((hash % 137) - 68) * 0.0007;
  return [base[0] + latJitter, base[1] + lngJitter];
}

export const COMMUNITY_TOWNS = [
  // Monmouth County
  { name: "Holmdel", coords: [40.3887, -74.1827], county: "Monmouth", phone: "(732) 555-0101" },
  { name: "Colts Neck", coords: [40.2879, -74.1693], county: "Monmouth", phone: "(732) 555-0102" },
  { name: "Rumson", coords: [40.3676, -73.9995], county: "Monmouth", phone: "(732) 555-0103" },
  { name: "Red Bank", coords: [40.3468, -74.0746], county: "Monmouth", phone: "(732) 555-0104" },
  { name: "Freehold", coords: [40.2590, -74.2721], county: "Monmouth", phone: "(732) 555-0105" },
  { name: "Manalapan", coords: [40.3379, -74.3249], county: "Monmouth", phone: "(732) 555-0106" },
  { name: "Marlboro", coords: [40.3468, -74.2596], county: "Monmouth", phone: "(732) 555-0107" },
  { name: "Long Branch", coords: [40.2987, -73.9876], county: "Monmouth", phone: "(732) 555-0108" },
  { name: "Wall", coords: [40.1629, -74.0668], county: "Monmouth", phone: "(732) 555-0109" },
  { name: "Ocean Township", coords: [40.2590, -74.0272], county: "Monmouth", phone: "(732) 555-0111" },
  { name: "Neptune", coords: [40.2012, -74.0384], county: "Monmouth", phone: "(732) 555-0112" },
  { name: "Asbury Park", coords: [40.2204, -74.0120], county: "Monmouth", phone: "(732) 555-0113" },
  { name: "Keyport", coords: [40.4373, -74.2016], county: "Monmouth", phone: "(732) 555-0114" },
  { name: "Howell", coords: [40.1762, -74.2027], county: "Monmouth", phone: "(732) 555-0115" },
  { name: "Middletown", coords: [40.3993, -74.1179], county: "Monmouth", phone: "(732) 555-0117" },
  { name: "Eatontown", coords: [40.2962, -74.0510], county: "Monmouth", phone: "(732) 555-0118" },
  { name: "Tinton Falls", coords: [40.3040, -74.0940], county: "Monmouth", phone: "(732) 555-0119" },
  { name: "Shrewsbury", coords: [40.3293, -74.0616], county: "Monmouth", phone: "(732) 555-0120" },
  { name: "Fair Haven", coords: [40.3618, -74.0380], county: "Monmouth", phone: "(732) 555-0121" },
  { name: "Little Silver", coords: [40.3382, -74.0410], county: "Monmouth", phone: "(732) 555-0122" },
  { name: "Deal", coords: [40.2530, -73.9960], county: "Monmouth", phone: "(732) 555-0123" },
  { name: "Belmar", coords: [40.1782, -74.0220], county: "Monmouth", phone: "(732) 555-0124" },
  { name: "Spring Lake", coords: [40.1527, -74.0278], county: "Monmouth", phone: "(732) 555-0125" },
  { name: "Manasquan", coords: [40.1268, -74.0487], county: "Monmouth", phone: "(732) 555-0126" },
  { name: "Hazlet", coords: [40.4158, -74.1748], county: "Monmouth", phone: "(732) 555-0130" },
  { name: "Aberdeen", coords: [40.4170, -74.2240], county: "Monmouth", phone: "(732) 555-0131" },
  { name: "Matawan", coords: [40.4148, -74.2299], county: "Monmouth", phone: "(732) 555-0132" },
  { name: "Farmingdale", coords: [40.1960, -74.1740], county: "Monmouth", phone: "(732) 555-0133" },
  { name: "Englishtown", coords: [40.2970, -74.3580], county: "Monmouth", phone: "(732) 555-0134" },
  // Ocean County
  { name: "Toms River", coords: [39.9537, -74.1979], county: "Ocean", phone: "(732) 555-0116" },
  { name: "Brick", coords: [40.0579, -74.1090], county: "Ocean", phone: "(732) 555-0110" },
  { name: "Point Pleasant", coords: [40.0832, -74.0682], county: "Ocean", phone: "(732) 555-0127" },
  { name: "Lakewood", coords: [40.0968, -74.2177], county: "Ocean", phone: "(732) 555-0128" },
  { name: "Jackson", coords: [40.0984, -74.3585], county: "Ocean", phone: "(732) 555-0129" },
  { name: "Barnegat", coords: [39.7532, -74.2229], county: "Ocean", phone: "(609) 555-0201" },
  { name: "Seaside Heights", coords: [39.9443, -74.0731], county: "Ocean", phone: "(732) 555-0202" },
  { name: "Lavallette", coords: [39.9707, -74.0688], county: "Ocean", phone: "(732) 555-0203" },
  { name: "Stafford", coords: [39.7003, -74.2640], county: "Ocean", phone: "(609) 555-0204" },
  { name: "Manahawkin", coords: [39.6943, -74.2590], county: "Ocean", phone: "(609) 555-0205" },
  // Middlesex County
  { name: "Old Bridge", coords: [40.4151, -74.3654], county: "Middlesex", phone: "(732) 555-0301" },
  { name: "Sayreville", coords: [40.4590, -74.3609], county: "Middlesex", phone: "(732) 555-0302" },
  { name: "South Amboy", coords: [40.4779, -74.2907], county: "Middlesex", phone: "(732) 555-0303" },
  { name: "East Brunswick", coords: [40.4278, -74.4157], county: "Middlesex", phone: "(732) 555-0304" },
  { name: "North Brunswick", coords: [40.4501, -74.4790], county: "Middlesex", phone: "(732) 555-0305" },
  { name: "New Brunswick", coords: [40.4863, -74.4518], county: "Middlesex", phone: "(732) 555-0306" },
  { name: "Edison", coords: [40.5187, -74.4121], county: "Middlesex", phone: "(732) 555-0307" },
  { name: "Woodbridge", coords: [40.5576, -74.2846], county: "Middlesex", phone: "(732) 555-0308" },
  { name: "Perth Amboy", coords: [40.5068, -74.2654], county: "Middlesex", phone: "(732) 555-0309" },
  { name: "Metuchen", coords: [40.5432, -74.3632], county: "Middlesex", phone: "(732) 555-0310" },
  { name: "South Plainfield", coords: [40.5751, -74.4115], county: "Middlesex", phone: "(732) 555-0311" },
  { name: "Piscataway", coords: [40.5569, -74.4601], county: "Middlesex", phone: "(732) 555-0312" },
  // Somerset County
  { name: "Franklin", coords: [40.4754, -74.5513], county: "Somerset", phone: "(908) 555-0401" },
  { name: "Bridgewater", coords: [40.5941, -74.6049], county: "Somerset", phone: "(908) 555-0402" },
  { name: "Somerville", coords: [40.5742, -74.6099], county: "Somerset", phone: "(908) 555-0403" },
  { name: "Bound Brook", coords: [40.5684, -74.5385], county: "Somerset", phone: "(908) 555-0404" },
  // Mercer County
  { name: "Princeton", coords: [40.3573, -74.6672], county: "Mercer", phone: "(609) 555-0501" },
  { name: "Hamilton", coords: [40.2267, -74.6929], county: "Mercer", phone: "(609) 555-0502" },
  { name: "Lawrence", coords: [40.2968, -74.7244], county: "Mercer", phone: "(609) 555-0503" },
  { name: "Ewing", coords: [40.2698, -74.7999], county: "Mercer", phone: "(609) 555-0504" },
  // Burlington County
  { name: "Mount Laurel", coords: [39.9340, -74.8910], county: "Burlington", phone: "(856) 555-0601" },
  { name: "Moorestown", coords: [39.9688, -74.9489], county: "Burlington", phone: "(856) 555-0602" },
  { name: "Burlington", coords: [40.0713, -74.8516], county: "Burlington", phone: "(609) 555-0603" },
  { name: "Medford", coords: [39.8546, -74.8227], county: "Burlington", phone: "(609) 555-0604" },
  // Bergen County
  { name: "Hackensack", coords: [40.8859, -74.0435], county: "Bergen", phone: "(201) 555-0701" },
  { name: "Paramus", coords: [40.9445, -74.0752], county: "Bergen", phone: "(201) 555-0702" },
  { name: "Fort Lee", coords: [40.8509, -73.9712], county: "Bergen", phone: "(201) 555-0703" },
  { name: "Englewood", coords: [40.8929, -73.9726], county: "Bergen", phone: "(201) 555-0704" },
  { name: "Ridgewood", coords: [40.9793, -74.1166], county: "Bergen", phone: "(201) 555-0705" },
  { name: "Teaneck", coords: [40.8976, -74.0160], county: "Bergen", phone: "(201) 555-0706" },
  // Essex County
  { name: "Newark", coords: [40.7357, -74.1724], county: "Essex", phone: "(973) 555-0801" },
  { name: "Montclair", coords: [40.8259, -74.2090], county: "Essex", phone: "(973) 555-0802" },
  { name: "Livingston", coords: [40.7879, -74.3150], county: "Essex", phone: "(973) 555-0803" },
  { name: "West Orange", coords: [40.7987, -74.2390], county: "Essex", phone: "(973) 555-0804" },
  { name: "Maplewood", coords: [40.7312, -74.2735], county: "Essex", phone: "(973) 555-0805" },
  { name: "Millburn", coords: [40.7260, -74.3245], county: "Essex", phone: "(973) 555-0806" },
  // Hudson County
  { name: "Jersey City", coords: [40.7178, -74.0431], county: "Hudson", phone: "(201) 555-0901" },
  { name: "Hoboken", coords: [40.7440, -74.0324], county: "Hudson", phone: "(201) 555-0902" },
  { name: "Weehawken", coords: [40.7693, -74.0218], county: "Hudson", phone: "(201) 555-0903" },
  { name: "North Bergen", coords: [40.8043, -74.0121], county: "Hudson", phone: "(201) 555-0904" },
  // Passaic County
  { name: "Wayne", coords: [40.9254, -74.2765], county: "Passaic", phone: "(973) 555-1001" },
  { name: "Clifton", coords: [40.8584, -74.1638], county: "Passaic", phone: "(973) 555-1002" },
  { name: "Passaic", coords: [40.8568, -74.1285], county: "Passaic", phone: "(973) 555-1003" },
  { name: "Paterson", coords: [40.9168, -74.1718], county: "Passaic", phone: "(973) 555-1004" },
  // Morris County
  { name: "Morristown", coords: [40.7968, -74.4816], county: "Morris", phone: "(973) 555-1101" },
  { name: "Parsippany", coords: [40.8578, -74.4260], county: "Morris", phone: "(973) 555-1102" },
  { name: "Denville", coords: [40.8924, -74.4774], county: "Morris", phone: "(973) 555-1103" },
  { name: "Madison", coords: [40.7598, -74.4174], county: "Morris", phone: "(973) 555-1104" },
  // Union County
  { name: "Westfield", coords: [40.6590, -74.3474], county: "Union", phone: "(908) 555-1201" },
  { name: "Summit", coords: [40.7156, -74.3646], county: "Union", phone: "(908) 555-1202" },
  { name: "Cranford", coords: [40.6584, -74.2996], county: "Union", phone: "(908) 555-1203" },
  { name: "Scotch Plains", coords: [40.6373, -74.3890], county: "Union", phone: "(908) 555-1204" },
  // Camden County
  { name: "Cherry Hill", coords: [39.9349, -74.9939], county: "Camden", phone: "(856) 555-1301" },
  { name: "Voorhees", coords: [39.8435, -74.9529], county: "Camden", phone: "(856) 555-1302" },
  { name: "Haddonfield", coords: [39.8915, -75.0378], county: "Camden", phone: "(856) 555-1303" },
  { name: "Collingswood", coords: [39.9184, -75.0713], county: "Camden", phone: "(856) 555-1304" },
  // Atlantic County
  { name: "Atlantic City", coords: [39.3643, -74.4229], county: "Atlantic", phone: "(609) 555-1401" },
  { name: "Margate", coords: [39.3276, -74.5035], county: "Atlantic", phone: "(609) 555-1402" },
  { name: "Ventnor", coords: [39.3404, -74.4774], county: "Atlantic", phone: "(609) 555-1403" },
  { name: "Egg Harbor", coords: [39.3790, -74.6489], county: "Atlantic", phone: "(609) 555-1404" },
  // Cape May County
  { name: "Cape May", coords: [38.9351, -74.9060], county: "Cape May", phone: "(609) 555-1501" },
  { name: "Wildwood", coords: [38.9918, -74.8149], county: "Cape May", phone: "(609) 555-1502" },
  { name: "Stone Harbor", coords: [39.0526, -74.7612], county: "Cape May", phone: "(609) 555-1503" },
  { name: "Avalon", coords: [39.1010, -74.7177], county: "Cape May", phone: "(609) 555-1504" },
  // Gloucester County
  { name: "Washington Township", coords: [39.7468, -75.0716], county: "Gloucester", phone: "(856) 555-1601" },
  { name: "Deptford", coords: [39.8319, -75.1046], county: "Gloucester", phone: "(856) 555-1602" },
  { name: "Woodbury", coords: [39.8382, -75.1527], county: "Gloucester", phone: "(856) 555-1603" },
  // --- NEW YORK ---
  { name: "Manhattan", coords: [40.7831, -73.9712], county: "New York", phone: "(212) 555-2001" },
  { name: "Brooklyn", coords: [40.6782, -73.9442], county: "Kings", phone: "(718) 555-2002" },
  { name: "Queens", coords: [40.7282, -73.7949], county: "Queens", phone: "(718) 555-2003" },
  { name: "Bronx", coords: [40.8448, -73.8648], county: "Bronx", phone: "(718) 555-2004" },
  { name: "Staten Island", coords: [40.5795, -74.1502], county: "Richmond", phone: "(718) 555-2005" },
  { name: "White Plains", coords: [41.0340, -73.7629], county: "Westchester", phone: "(914) 555-2101" },
  { name: "Yonkers", coords: [40.9312, -73.8988], county: "Westchester", phone: "(914) 555-2102" },
  { name: "New Rochelle", coords: [40.9115, -73.7824], county: "Westchester", phone: "(914) 555-2103" },
  { name: "Scarsdale", coords: [40.9887, -73.7846], county: "Westchester", phone: "(914) 555-2104" },
  { name: "Rye", coords: [40.9826, -73.6835], county: "Westchester", phone: "(914) 555-2105" },
  { name: "Garden City", coords: [40.7268, -73.6343], county: "Nassau", phone: "(516) 555-2201" },
  { name: "Great Neck", coords: [40.8007, -73.7285], county: "Nassau", phone: "(516) 555-2202" },
  { name: "Manhasset", coords: [40.7979, -73.6990], county: "Nassau", phone: "(516) 555-2203" },
  { name: "Rockville Centre", coords: [40.6587, -73.6413], county: "Nassau", phone: "(516) 555-2204" },
  { name: "Hempstead", coords: [40.7062, -73.6187], county: "Nassau", phone: "(516) 555-2205" },
  { name: "Huntington", coords: [40.8682, -73.4257], county: "Suffolk", phone: "(631) 555-2301" },
  { name: "Smithtown", coords: [40.8559, -73.2007], county: "Suffolk", phone: "(631) 555-2302" },
  { name: "Babylon", coords: [40.6957, -73.3257], county: "Suffolk", phone: "(631) 555-2303" },
  { name: "Islip", coords: [40.7298, -73.2104], county: "Suffolk", phone: "(631) 555-2304" },
  { name: "Southampton", coords: [40.8843, -72.3893], county: "Suffolk", phone: "(631) 555-2305" },
  { name: "Nyack", coords: [41.0907, -73.9174], county: "Rockland", phone: "(845) 555-2401" },
  { name: "Tarrytown", coords: [41.0762, -73.8585], county: "Westchester", phone: "(914) 555-2106" },
  { name: "Peekskill", coords: [41.2901, -73.9204], county: "Westchester", phone: "(914) 555-2107" },
  { name: "Newburgh", coords: [41.5034, -74.0104], county: "Orange", phone: "(845) 555-2501" },
  // --- PENNSYLVANIA ---
  { name: "Philadelphia Center City", coords: [39.9526, -75.1652], county: "Philadelphia", phone: "(215) 555-3001" },
  { name: "Rittenhouse", coords: [39.9490, -75.1720], county: "Philadelphia", phone: "(215) 555-3002" },
  { name: "Old City", coords: [39.9523, -75.1426], county: "Philadelphia", phone: "(215) 555-3003" },
  { name: "University City", coords: [39.9522, -75.1932], county: "Philadelphia", phone: "(215) 555-3004" },
  { name: "Fishtown", coords: [39.9714, -75.1340], county: "Philadelphia", phone: "(215) 555-3005" },
  { name: "Doylestown", coords: [40.3101, -75.1299], county: "Bucks", phone: "(215) 555-3101" },
  { name: "New Hope", coords: [40.3640, -74.9510], county: "Bucks", phone: "(215) 555-3102" },
  { name: "Newtown", coords: [40.2293, -74.9368], county: "Bucks", phone: "(215) 555-3103" },
  { name: "Langhorne", coords: [40.1743, -74.9224], county: "Bucks", phone: "(215) 555-3104" },
  { name: "King of Prussia", coords: [40.0893, -75.3963], county: "Montgomery PA", phone: "(610) 555-3201" },
  { name: "Ardmore", coords: [40.0068, -75.2860], county: "Montgomery PA", phone: "(610) 555-3202" },
  { name: "Conshohocken", coords: [40.0793, -75.3035], county: "Montgomery PA", phone: "(610) 555-3203" },
  { name: "Bryn Mawr", coords: [40.0210, -75.3163], county: "Montgomery PA", phone: "(610) 555-3204" },
  { name: "Allentown", coords: [40.6084, -75.4902], county: "Lehigh", phone: "(610) 555-3301" },
  { name: "Bethlehem", coords: [40.6259, -75.3705], county: "Northampton", phone: "(610) 555-3302" },
  { name: "Easton", coords: [40.6868, -75.2207], county: "Northampton", phone: "(610) 555-3303" },
  // --- CONNECTICUT ---
  { name: "Stamford", coords: [41.0534, -73.5387], county: "Fairfield CT", phone: "(203) 555-4001" },
  { name: "Greenwich", coords: [41.0262, -73.6282], county: "Fairfield CT", phone: "(203) 555-4002" },
  { name: "Westport", coords: [41.1415, -73.3579], county: "Fairfield CT", phone: "(203) 555-4003" },
  { name: "Norwalk", coords: [41.1177, -73.4082], county: "Fairfield CT", phone: "(203) 555-4004" },
  { name: "Darien", coords: [41.0787, -73.4690], county: "Fairfield CT", phone: "(203) 555-4005" },
  { name: "Fairfield", coords: [41.1412, -73.2637], county: "Fairfield CT", phone: "(203) 555-4006" },
  { name: "New Haven", coords: [41.3083, -72.9279], county: "New Haven CT", phone: "(203) 555-4101" },
  { name: "Milford", coords: [41.2223, -73.0568], county: "New Haven CT", phone: "(203) 555-4102" },
  { name: "Hamden", coords: [41.3959, -72.8968], county: "New Haven CT", phone: "(203) 555-4103" },
  { name: "Guilford", coords: [41.2890, -72.6818], county: "New Haven CT", phone: "(203) 555-4104" },
  // --- DELAWARE ---
  { name: "Wilmington", coords: [39.7391, -75.5398], county: "New Castle", phone: "(302) 555-5001" },
  { name: "Newark DE", coords: [39.6837, -75.7497], county: "New Castle", phone: "(302) 555-5002" },
  { name: "Greenville", coords: [39.7998, -75.6002], county: "New Castle", phone: "(302) 555-5003" },
  { name: "Middletown DE", coords: [39.4496, -75.7163], county: "New Castle", phone: "(302) 555-5004" },
];


// --- Training Partners ---
export const PARTNER_ACTIVITIES = [
  "Running", "Walking", "Cycling", "Strength Training", "Yoga", "Pilates",
  "Swimming", "Tennis", "Pickleball", "Hiking", "CrossFit", "Boxing", "Meditation", "Golf",
];

export const PARTNER_AVAILABILITY = [
  "Weekday Mornings", "Weekday Afternoons", "Weekday Evenings",
  "Weekend Mornings", "Weekend Afternoons", "Weekend Evenings",
];

export const EXPERIENCE_LEVELS = ["beginner", "intermediate", "advanced"];

export function partnerInitials(name) {
  return (name || "?").split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase();
}

export const DOMAINS = [
  "D1 Metabolic", "D2 Hormonal", "D3 Mitochondrial", "D4 Sleep",
  "D5 Stress/HPA", "D6 Gut", "D7 Cardiovascular", "D8 Immune",
  "D9 Neurocognitive", "D10 Methylation",
];

export const CATEGORIES = [
  { key: "all", label: "All", emoji: "" },
  { key: "nutrition", label: "Nutrition", emoji: "" },
  { key: "fitness", label: "Fitness", emoji: "" },
  { key: "recovery", label: "Recovery", emoji: "" },
  { key: "services", label: "Services", emoji: "" },
];

export const SERVICE_OPTIONS = [
  "Health and wellness coaching", "Counseling / therapy services", "Nutrition counseling services",
  "Acupuncture services", "Chiropractic services", "Personal training", "Physical therapy services",
  "Occupational therapy services", "Naturopathic services", "Hypnotherapy services", "Reiki services",
  "Rolfing services", "Ayurvedic wellness services", "Traditional Chinese medicine services",
];

// Symptom / condition → CPI domain mapping for search
export const SYMPTOM_DOMAIN_MAP = {
  "inflammation": ["D1 Metabolic", "D8 Immune"],
  "blood sugar": ["D1 Metabolic"],
  "insulin": ["D1 Metabolic"],
  "diabetes": ["D1 Metabolic"],
  "metabolic": ["D1 Metabolic"],
  "weight": ["D1 Metabolic", "D6 Gut"],
  "thyroid": ["D2 Hormonal"],
  "hormone": ["D2 Hormonal"],
  "adrenal": ["D2 Hormonal", "D5 Stress/HPA"],
  "estrogen": ["D2 Hormonal"],
  "testosterone": ["D2 Hormonal"],
  "pcos": ["D2 Hormonal"],
  "fatigue": ["D3 Mitochondrial", "D2 Hormonal"],
  "energy": ["D3 Mitochondrial"],
  "recovery": ["D3 Mitochondrial"],
  "mitochondria": ["D3 Mitochondrial"],
  "sleep": ["D4 Sleep"],
  "insomnia": ["D4 Sleep"],
  "melatonin": ["D4 Sleep"],
  "circadian": ["D4 Sleep"],
  "stress": ["D5 Stress/HPA"],
  "anxiety": ["D5 Stress/HPA", "D9 Neurocognitive"],
  "cortisol": ["D5 Stress/HPA"],
  "burnout": ["D5 Stress/HPA"],
  "gut": ["D6 Gut"],
  "ibs": ["D6 Gut"],
  "digestion": ["D6 Gut"],
  "microbiome": ["D6 Gut"],
  "bloating": ["D6 Gut"],
  "leaky gut": ["D6 Gut"],
  "food sensitivity": ["D6 Gut"],
  "heart": ["D7 Cardiovascular"],
  "blood pressure": ["D7 Cardiovascular"],
  "cholesterol": ["D7 Cardiovascular"],
  "cardiovascular": ["D7 Cardiovascular"],
  "immune": ["D8 Immune"],
  "autoimmune": ["D8 Immune"],
  "allergy": ["D8 Immune"],
  "brain": ["D9 Neurocognitive"],
  "focus": ["D9 Neurocognitive"],
  "memory": ["D9 Neurocognitive"],
  "cognitive": ["D9 Neurocognitive"],
  "adhd": ["D9 Neurocognitive"],
  "depression": ["D9 Neurocognitive", "D5 Stress/HPA"],
  "methylation": ["D10 Methylation"],
  "mthfr": ["D10 Methylation"],
  "dna": ["D10 Methylation"],
  "detox": ["D10 Methylation", "D6 Gut"],
};

// Wellness goal → { domains, categories }
export const WELLNESS_GOALS = {
  "Lose Weight":        { domains: ["D1 Metabolic", "D6 Gut"], categories: ["nutrition", "fitness"] },
  "Build Strength":     { domains: ["D3 Mitochondrial", "D7 Cardiovascular"], categories: ["fitness"] },
  "Reduce Stress":      { domains: ["D5 Stress/HPA", "D4 Sleep"], categories: ["recovery", "fitness"] },
  "Improve Sleep":      { domains: ["D4 Sleep", "D5 Stress/HPA"], categories: ["recovery"] },
  "Boost Energy":       { domains: ["D3 Mitochondrial", "D2 Hormonal"], categories: ["nutrition", "fitness"] },
  "Eat Healthier":      { domains: ["D1 Metabolic", "D6 Gut", "D10 Methylation"], categories: ["nutrition"] },
  "Recover & Heal":     { domains: ["D3 Mitochondrial", "D8 Immune"], categories: ["recovery"] },
  "Improve Flexibility": { domains: ["D3 Mitochondrial", "D5 Stress/HPA"], categories: ["fitness"] },
  "Mental Clarity":     { domains: ["D9 Neurocognitive", "D5 Stress/HPA"], categories: ["recovery", "nutrition"] },
  "Quit Addiction":     { domains: ["D5 Stress/HPA", "D9 Neurocognitive"], categories: ["recovery"] },
  "Heart Health":       { domains: ["D7 Cardiovascular", "D1 Metabolic"], categories: ["nutrition", "fitness"] },
  "Boost Immunity":     { domains: ["D8 Immune", "D6 Gut"], categories: ["nutrition", "recovery"] },
};

